module.exports = __webpack_public_path__ + "img/b0309_11.5c744c9e.png";